/* eslint-disable react-refresh/only-export-components */
import { ColumnHelper } from "@tanstack/react-table";
import { ManageRolesTableDataItem } from "PFApp/activities/manage_roles/manage_roles.types";
import { RolesFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { ManageRolesMultiForm } from "PFApp/types/activity_form/manage_roles_form_schema";
import { Flex } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useWatch } from "react-hook-form";

import { useCalculateEngagementRowSpan } from "../hooks/use_calculate_engagement_rowspan";
import css from "./cell.module.scss";

const ENGAGEMENT_COLUMN_WIDTH = 150;

type EngagementCellProps = {
  rolesFormKey: RolesFormKey;
  rowIndex: number;
};

const EngagementCell = ({ rolesFormKey, rowIndex }: EngagementCellProps) => {
  const fieldKey = `${rolesFormKey}.${rowIndex}.engagement_name` as const;
  const engagementName = useWatch<ManageRolesMultiForm>({ name: fieldKey }) as string | undefined;

  return (
    <Flex className={css.cell}>
      <Typography variant="bodyRegular" title={engagementName ? engagementName : undefined}>
        {engagementName ?? "-"}
      </Typography>
    </Flex>
  );
};

type EngagementRowSpanMeta = ReturnType<typeof useCalculateEngagementRowSpan>;

export const createEngagementColumn = (
  columnHelper: ColumnHelper<ManageRolesTableDataItem>,
  rolesFormKey: RolesFormKey,
  headerLabel: string,
  engagementRowSpan?: EngagementRowSpanMeta
) =>
  columnHelper.accessor((row) => row, {
    id: "engagement_name",
    header: () => <span>{headerLabel}</span>,
    cell: (info) => <EngagementCell rolesFormKey={rolesFormKey} rowIndex={info.row.index} />,
    size: ENGAGEMENT_COLUMN_WIDTH,
    meta: {
      getIsCopyPasteBlocked: () => true,
      ...(engagementRowSpan
        ? {
            getRowSpan: engagementRowSpan.getRowSpan,
            isRowSpanHidden: engagementRowSpan.isRowSpanHidden
          }
        : {})
    }
  });
